import styled from 'styled-components';
import Colors from 'library/constants/colors';
import { Link } from 'react-router-dom';

const Container = styled.nav`
  border-right: 2px solid ${Colors.shade06};
  color: ${Colors.shade03};
  background-color: ${Colors.shade08};
  height: calc(100vh - 71px);
  position: sticky;
  top: 71px;
  
  ul {
    padding: 0;
    margin: 0;
  }
  
  li {
    display: block;
    position: relative;
    width: 72px;
    padding: 9px 0 12px;
    text-align: center;
    cursor: pointer;
    
    i {
      display: block;
      font-size: 28px;
    }
    
    &:hover {
      background-color: ${Colors.shade07};
      color: ${Colors.violet};
    }
  }
`;

const StyledLink = styled(Link)`
  ${({ disabled }) => (disabled ? `
    display: inline-block;
    color: ${Colors.shade09};
    pointer-events: none;
    text-decoration: none;
    cursor: not-allowed;
  ` : '')};
`;

const ListItem = styled.li`
  ${({ isActive }) => isActive && `
    cursor: default;
    background-color: ${Colors.shade07};
    color: ${Colors.violet};
      
    &:after {
      content: '';
      position: absolute;
      height: 100%;
      width: 2px;
      top: 0;
      right: -2px;
      background-color: ${Colors.violet};
    }
  `}
`;

// eslint-disable-next-line import/prefer-default-export
export { Container, ListItem, StyledLink };
